var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1440_3915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.0004C6.477 22.0004 2 17.5234 2 12.0004C2 6.4774 6.477 2.0004 12 2.0004C17.523 2.0004 22 6.4774 22 12.0004C22 17.5234 17.523 22.0004 12 22.0004ZM12 20.0004C14.1217 20.0004 16.1566 19.1575 17.6569 17.6573C19.1571 16.157 20 14.1221 20 12.0004C20 9.87866 19.1571 7.84383 17.6569 6.34354C16.1566 4.84325 14.1217 4.0004 12 4.0004C9.87827 4.0004 7.84344 4.84325 6.34315 6.34354C4.84285 7.84383 4 9.87866 4 12.0004C4 14.1221 4.84285 16.157 6.34315 17.6573C7.84344 19.1575 9.87827 20.0004 12 20.0004ZM8.5 14.0004H14C14.1326 14.0004 14.2598 13.9477 14.3536 13.854C14.4473 13.7602 14.5 13.633 14.5 13.5004C14.5 13.3678 14.4473 13.2406 14.3536 13.1468C14.2598 13.0531 14.1326 13.0004 14 13.0004H10C9.33696 13.0004 8.70107 12.737 8.23223 12.2682C7.76339 11.7993 7.5 11.1634 7.5 10.5004C7.5 9.83736 7.76339 9.20147 8.23223 8.73263C8.70107 8.26379 9.33696 8.0004 10 8.0004H11V6.0004H13V8.0004H15.5V10.0004H10C9.86739 10.0004 9.74021 10.0531 9.64645 10.1468C9.55268 10.2406 9.5 10.3678 9.5 10.5004C9.5 10.633 9.55268 10.7602 9.64645 10.854C9.74021 10.9477 9.86739 11.0004 10 11.0004H14C14.663 11.0004 15.2989 11.2638 15.7678 11.7326C16.2366 12.2015 16.5 12.8374 16.5 13.5004C16.5 14.1634 16.2366 14.7993 15.7678 15.2682C15.2989 15.737 14.663 16.0004 14 16.0004H13V18.0004H11V16.0004H8.5V14.0004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1440_3915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.5e8a8be628148f99d1e19b9951da6d9f.svg";
export { ForwardRef as ReactComponent };